import { Browser } from "@capacitor/browser"
import { isPlatform } from "@ionic/vue"

export function usePlatform() {
    function isCapacitor(): boolean {
        return isPlatform("capacitor")
    }

    async function openLink(url: string) {
        if (isCapacitor()) {
            await Browser.open({
                url,
                toolbarColor: "#0055A5;",
                presentationStyle: "popover"
            })
        }
        else
            window.open(url, "_blank")
    }

    return {
        isCapacitor,
        openLink
    }
}
